// extracted by mini-css-extract-plugin
module.exports = {"label":"FormCheck_label__2ZyjW"};